<script>
  import ApplicationState from "../../../Stores/applicationStates"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import { push } from "svelte-spa-router"

  /**
   * Array containing items for export.
   * @type {Array}
   */
  export let items = []

  /**
   * Represents the current hash location in the browser.
   * @type {string}
   */
  let currentContent = location.hash
</script>

<!-- border-b border-gray-100 -->
<div class="mt-2 h-full rounded-md bg-white pt-1 shadow-sm dark:border-transparent dark:bg-mdGray sm:mt-0 sm:rounded-none">
  <div class="h-full gap-6 p-1 font-bold text-gray-d00 sm:mx-auto sm:flex sm:w-10/12 sm:p-0 sm:pl-6 xl:w-4/6 2xl:w-3/5">
    {#if items}
      {#each items as item}
        {#if $ApplicationState.badgeEnabled || (!$ApplicationState.badgeEnabled && !item.id.includes("badge"))}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <a
            href={item.route}
            on:click={() => {
              // Update currentContent with the clicked item's route
              currentContent = item.route
              dispatch("mobileMenu") // Dispatch 'mobileMenu' action
            }}
            class="] flex w-auto cursor-pointer items-center gap-2 rounded-md py-2 pl-4 text-base dark:hover:bg-transparent dark:hover:text-[#FF6A00] sm:rounded-none sm:bg-none sm:px-1 sm:text-xs sm:hover:text-[#FF6A00] md:text-sm md:dark:hover:bg-transparent {location.hash.startsWith(item.route) ? 'rounded-none border-l-4 border-[#FF6A00] text-[#FF6A00] sm:border-b-[3px] sm:border-l-0' : 'border-l-4 border-transparent text-gray-d00 dark:text-gray-200 sm:border-b-[3px] sm:border-l-0'}"
          >
            <div class="flex w-3 justify-center">
              <i class={item.iconClasses} />
            </div>
            <p class="sm:w-full">{item.title}</p>
          </a>
        {/if}
      {/each}
    {/if}
  </div>
</div>
